export default __webpack_public_path__ + "static/media/battery-4-light.618c277b.svg";